import { TimeTrackingDayEntry } from 'src/tabs/models/TimesheetsInterface';
import { isSameDay } from './isSameDay';

export const mapDayEntriesEmptyCells = (
  data: TimeTrackingDayEntry[],
  weekDays: string[]
) => {
  const assignmentData = [];
  weekDays.map((weekDay) => {
    const dayEntry = data.find((_dayEntry) =>
      isSameDay(_dayEntry.new_date, weekDay)
    );

    if (dayEntry) {
      assignmentData.push(dayEntry);
    } else if (!dayEntry) {
      assignmentData.push({
        new_date: weekDay,
      });
    }
  });

  return assignmentData;
};
